module.exports = __webpack_public_path__ + "static/media/house-4.5601794a.jpeg";